import { css } from 'styled-components';

const AntDesignOverrides = css`
  .zero-padding-dropdown {
    .ant-dropdown-menu-item {
      padding: 0 !important;
    }
  }

  .ant-layout-has-sider {
    background-color: var(--bg-dark-color) !important;
  }

  * {
    .ant-menu-submenu-popup {
      display: none;
    }
  }

  /* Force enable text selection for all inputs and textareas */
  *:where(input),
  *:where(textarea),
  .ant-input,
  .ant-input-number,
  .ant-input-textarea,
  .ant-input input,
  .ant-input-number input,
  .ant-input-textarea textarea {
    user-select: text !important;
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
  }

  /* Modal and related components */
  .ant-modal,
  .ant-modal-content,
  .ant-modal-body,
  *:where(.ant-modal),
  *:where(.ant-modal-content),
  *:where(.ant-modal-body) {
    user-select: text !important;
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
  }

  /* Ensure children of modals can select text */
  .ant-modal * {
    user-select: text !important;
    -webkit-user-select: text !important;
  }
`;

export { AntDesignOverrides };
